import { getMongoDb } from "@swoft/persistence";
import { ITaskRepository } from '../../ports/ITaskRepository';
import { TaskAggregate } from '../../domain/entities/TaskAggregate';
import { TaskSchema } from '../../domain/view-models';
import { GTD_COLLECTIONS } from '../../../../config/collections';

/**
 * MongoDB implementation of ITaskRepository
 */
export class TaskMongoRepository implements ITaskRepository {
  private readonly collectionName = GTD_COLLECTIONS.TASK_ASSIGNMENTS;

  async save(task: TaskAggregate): Promise<void> {
    const dto = task.toDTO();
    const assignment = {
      productId: dto.productId,
      taskId: dto.id,
      partyId: dto.assignedTo,
      roleType: dto.roleType,
      assignedAt: dto.assignedAt,
    };
    const db = getMongoDb();
    await db.collection(this.collectionName).updateOne(
      { taskId: dto.id },
      { $set: assignment },
      { upsert: true }
    );
  }

  async getById(taskId: string): Promise<TaskAggregate> {
    const db = getMongoDb();
    const doc: any = await db.collection(this.collectionName).findOne({ taskId });
    if (!doc) throw new Error(`Assignment for taskId ${taskId} not found`);
    const dto = TaskSchema.parse({
      id: doc.taskId,
      title: '',
      context: [],
      priority: 'medium',
      status: 'in-progress',
      inboxItemId: undefined,
      due: undefined,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      assignedTo: doc.partyId,
      roleType: doc.roleType,
      assignedAt: doc.assignedAt,
    });
    return TaskAggregate.fromDTO(dto);
  }

  async listByProduct(productId: string): Promise<TaskAggregate[]> {
    const db = getMongoDb();
    const docs: any[] = await db.collection(this.collectionName).find({ productId }).toArray();
    return docs.map((doc: any) => {
      const dto = TaskSchema.parse({
        id: doc.taskId,
        title: '',
        context: [],
        priority: 'medium',
        status: 'in-progress',
        inboxItemId: undefined,
        due: undefined,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        assignedTo: doc.partyId,
        roleType: doc.roleType,
        assignedAt: doc.assignedAt,
      });
      return TaskAggregate.fromDTO(dto);
    });
  }
}
